import { Component, Injectable, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-logout',
  template: `
    <div class="logout-container">
      <div class="logout-message">
        <h2 *ngIf="!isSessionExpired">You have been successfully logged out</h2>
        <h2 *ngIf="isSessionExpired">Session expired due to inactivity</h2>
        <p>Redirecting to login page in {{ countdown }} seconds...</p>
      </div>
    </div>
  `,
  styles: [`
    .logout-container {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100vh;
      background-color: #f5f5f5;
    }
    .logout-message {
      text-align: center;
      background: white;
      padding: 2rem;
      border-radius: 8px;
      box-shadow: 0 2px 10px rgba(0,0,0,0.1);
    }
    p {
      margin-top: 1rem;
      color: #666;
      font-size: 16px;
    }
  `]
})
@Injectable({
  providedIn: 'root'
})
export class LogoutComponent implements OnInit {
  countdown = 3;
  isSessionExpired = false;

  constructor(private router: Router) {}

  ngOnInit() {

    const sessionExpiry = localStorage.getItem('sessionExpiry');
    this.isSessionExpired = sessionExpiry === 'true';
    // Clear the sessionExpiry flag after reading it
    localStorage.removeItem('sessionExpiry');    
    const interval = setInterval(() => {
      this.countdown--;
      if (this.countdown === 0) {
        clearInterval(interval);
        this.router.navigate(['/']);
      }
    }, 1000);
  }
}
